import { FiBell, FiDollarSign, FiPlay } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";
import { useWindowSize } from "./useWindowSize";
import { useState } from "react";

const VerticalAccordion = () => {
  const [open, setOpen] = useState(items[0].id);

  return (
    <section className="p-4 bg-[#1111]">
      <div className="flex flex-col lg:flex-row h-fit lg:h-[450px] w-full max-w-6xl mx-auto shadow overflow-hidden">
        {items.map((item) => {
          return (
            <Panel
              key={item.id}
              open={open}
              setOpen={setOpen}
              id={item.id}
              
              title={item.title}
              imgSrc={item.imgSrc}
              description={item.description}
            />
          );
        })}
      </div>
    </section>
  );
};

const Panel = ({ open, setOpen, id, title, imgSrc, description }) => {
    const { width } = useWindowSize();
    const isOpen = open === id;
  
    return (
      <>
        <button
          className="bg-white hover:bg-slate-50 transition-colors p-3 border-r-[1px] border-b-[1px] border-slate-200 flex flex-row-reverse lg:flex-col justify-end items-center gap-4 relative group text-black"
          onClick={() => setOpen(id)}
        >
          {/* Vertical Title */}
          <span
            style={{
              writingMode: "vertical-lr",
            }}
            className="hidden lg:block text-xl font-light rotate-180 text-black" // Updated to `text-white`
          >
            {title}
          </span>
          {/* Horizontal Title */}
          <span className="block lg:hidden text-xl text-black">{title}</span> {/* Updated to `text-white` */}
         
          <span className="w-4 h-4 bg-white group-hover:bg-slate-50 transition-colors border-r-[1px] border-b-[1px] lg:border-b-0 lg:border-t-[1px] border-slate-200 rotate-45 absolute bottom-0 lg:bottom-[50%] right-[50%] lg:right-0 translate-y-[50%] translate-x-[50%] z-20" />
        </button>
  
        <AnimatePresence>
          {isOpen && (
            <motion.div
              key={`panel-${id}`}
              variants={width && width > 1024 ? panelVariants : panelVariantsSm}
              initial="closed"
              animate="open"
              exit="closed"
              style={{
                backgroundImage: `url(${imgSrc})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              className="w-full h-full overflow-hidden relative bg-white flex items-end"
            >
              <motion.div
                variants={descriptionVariants}
                initial="closed"
                animate="open"
                exit="closed"
                className="px-4 py-2 bg-black/40 backdrop-blur-sm text-white" // Updated to ensure description text is white
              >
                <p className="text-white">{description}</p> {/* Updated to `text-white` */}
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </>
    );
  };

export default VerticalAccordion;

const panelVariants = {
  open: {
    width: "100%",
    height: "100%",
  },
  closed: {
    width: "0%",
    height: "100%",
  },
};

const panelVariantsSm = {
  open: {
    width: "100%",
    height: "200px",
  },
  closed: {
    width: "100%",
    height: "0px",
  },
};

const descriptionVariants = {
  open: {
    opacity: 1,
    y: "0%",
    transition: {
      delay: 0.125,
    },
  },
  closed: { opacity: 0, y: "100%" },
};

const items = [
  {
    id: 1,
    title: "Military-grade encryption (e.g., AES-256).",

    imgSrc: "/legal/mil.jpeg",
    description:
      "Military-grade encryption, like AES-256, ensures top-level data protection with advanced algorithms, safeguarding sensitive information against unauthorized access.",
  },
  {
    id: 2,
    title: "Quantum-resistant protocols.",

    imgSrc:
      "/legal/quantam.jpg",
    description:
      "Quantum-resistant protocols provide future-proof security, protecting sensitive data against potential threats from powerful quantum computing advancements",
  },
  {
    id: 3,
    title: "Regular audits and certifications.",
   
    imgSrc: "/legal/robot.jpg",
    description:
      "Regular audits and certifications, like SOC 2 and ISO 27001, ensure compliance, data security, and trust through rigorous standards.",
  },

];